import { CERTIFICATION_TYPES, OTHER_DOCUMENT_TYPES } from "../configs/constants/DocumentTypes";

export const certificationTypes = Object.keys(CERTIFICATION_TYPES);
export const otherDocumentTypes = Object.keys(OTHER_DOCUMENT_TYPES).filter((t) => t !== "OTHER");
